/**
 * pika-shared package
 *
 * This package contains shared types, utilities, and other code used across the Pika project.
 *
 * You can import specific modules using direct paths:
 * import { ChatUser } from 'pika-shared/types/chatbot/chatbot';
 * import { apiGatewayFunctionDecorator } from 'pika-shared/util/api-gateway-utils';
 */

export const packageInfo = {
    name: 'pika-shared',
    description: 'Shared utilities and types for Pika project'
};
